/* ==================================================
  お気に入り店舗の閉店状態判定ユーティリティ
===================================================*/

/*  ステータス
  - active   : ①営業中（closedAtなし、isClosed=false）
  - closing  : ②閉店予定（today < closedAt）
  - closed   : ③閉店〜半年間（closedAt ≦ today < closedAt+6ヶ月）
  - archived : ④半年超過、または closedAtなし & isClosed=true
*/
/*  判定優先順位
  closedAt（閉店日付）ベースの判定を最優先とし、
  isClosed は closedAt が SDK から返却されないケースのフォールバックとして扱う。
  ②閉店決定時点で isClosed=true が立つ運用を想定し、
  isClosed を最優先にしないことで②③が誤って archived 扱いになるのを防ぐ。
*/
window.getStoreStatus = function (location) {
  if (!location) return 'archived';

  const closedAt = location.closedAt ? new Date(location.closedAt) : null;

  /*  closedAtがある場合は日付ベースで判定（isClosedより優先）  */
  if (closedAt && !isNaN(closedAt.getTime())) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const closedDate = new Date(closedAt);
    closedDate.setHours(0, 0, 0, 0);

    if (today < closedDate) return 'closing';

    const sixMonthsLater = new Date(closedDate);
    sixMonthsLater.setMonth(sixMonthsLater.getMonth() + 6);

    if (today < sixMonthsLater) return 'closed';
    return 'archived';
  }

  /*  closedAtが無い場合のフォールバック  */
  if (location.isClosed) return 'archived';
  return 'active';
};
